export default {
	functional: true,
	name: 'MessageTag',
	props: {
		text: {
			type: String,
			require: true,
		},
	},
	render(h, context) {
		return h(
			'span',
			{
				class: 'global-message-tag',
			},
			context.props.text
		);
	},
};



// WEBPACK FOOTER //
// ./src/components/common/MessageTag.js